<template>
  <main class="wrap">
    <Loading v-if="!topicWrapper"></Loading>
    <div v-else class="topic">
      <Top :topicWrapper="topicWrapper" :openApp="openApp" />
      <Content 
        :voteOptions="topicWrapper.voteOptions" 
        :topicFeedWrappers="topicFeedWrappers"
        :openApp="openApp"
      />
      <ShareBottom :openApp="openApp" />
    </div>
  </main>
</template>
<script>
import Loading from '../../../vue-components/components/Loading'
import Top from '../components/topic/Top'
import Content from '../components/topic/Content'
import ShareBottom from '../../../vue-components/components/ShareBottom'
import {openAppSnail} from 'nw-app-snail'

export default {
  name: 'Topic',
  components: {
    Loading,
    Top,
    Content,
    ShareBottom
  },
  data() {
    return {
      topicId: '',
      topicWrapper: null,
      topicFeedWrappers: null
    }
  },
  created() {
    this.getTopicId()
    this.getTopicDetail()
    this.getTopicFeed()
  },
  methods: {
    openApp(){
      openAppSnail({
        path: 'topicDetail',
        query: {
          topicId: this.topicId
        }
      })
    },
    getTopicId() {
      const match = location.href.match(/\/topic\/(\d+)/)
      this.topicId = match[1]
    },
    async getTopicDetail() {
      try {
        let res = await this.$http.get('/api/topic/detail.json', {
          params: {
            topicId: this.topicId
          }
        })
        this.topicWrapper = res.body.topicWrapper
        document.title = this.topicWrapper.topic.title
      } catch(err) {
        console.log(err)
      }
    },
    async getTopicFeed() {
      try {
        let res = await this.$http.get('/api/topic/feed/list.json', {
          params: {
            topicId: this.topicId,
            order: 'hot',
            page: 1,
            pageSize: 4
          }
        })
        this.topicFeedWrappers = res.body.topicFeedWrappers && res.body.topicFeedWrappers.slice(0, 3)
      } catch(err) {
        console.log(err)
      }
    }
  }
}
</script>
<style lang="scss">
@import '../../../css/component/reset.css';
html,body{
  height: 100%;
}
.wrap {
  background: #ffffff;
  position: relative;
  min-height: 100%;
  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
}
</style>
